import { render, staticRenderFns } from "./TabelaFormularioContatos.vue?vue&type=template&id=58f252da&"
import script from "./TabelaFormularioContatos.vue?vue&type=script&lang=js&"
export * from "./TabelaFormularioContatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports